import React, {useState} from 'react';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Button, Divider, Layout, Text } from '@ui-kitten/components';
import { StyleSheet, ScrollView } from 'react-native';
import { AvatarH } from './avatar.js';
import { Edit } from './edit-profile.js';
import { Action } from './action-list.js';
import { Settings } from './users-list.js';
import { useIsFocused } from "@react-navigation/native";
import { StatusBar } from 'expo-status-bar';
import Constants from "expo-constants"
import * as RootNavigation from '../../../root.navigation.js';
import { useSelector} from 'react-redux';

export const SupervisorScreen = () => {
  const isVisible = useIsFocused();
  const user =  useSelector( state => state.login.information);

  React.useEffect(()=>{
    console.log('test refreshing!');
  }, [isVisible])

  return (
      <Layout style={styles.container}>
        <Layout style={{backgroundColor:'#134A93'}}>
          <AvatarH />
        </Layout>
        <Divider />
        { user.supervisor == '1' &&
        <Layout level='4' style={{flexDirection: 'row' , alignItems: 'center' , justifyContent: 'space-between' ,marginVertical: 6, paddingVertical: 10}}>
        <Text appearance='hint' category='c2' style={{marginHorizontal:20}}>افزودن زیرمجموعه</Text>
        <Button  size='tiny' onPress={()=>{RootNavigation.navigate('AddSupervisor')}} status='primary' style={{borderRadius:5, marginHorizontal:5, flex: 1}}>افــــزودن</Button>
        </Layout>
}
        <Layout level='2' style={{flex:1}}>
          <ScrollView>
          <Text appearance='hint' category='c2' style={{marginHorizontal:20,marginTop:8}}>کاربران زیر مجموعه / سوپروایزر</Text>
          <Settings />
          {
          // <Text appearance='hint' category='c2' style={{marginHorizontal:20,marginTop:8}}>پشتیبانی</Text>
          // <Action />
        }
          </ScrollView>
          <Button style={{borderRadius:0,height: 40}} onPress={()=>{RootNavigation.navigate('profile')}}>بازگشت</Button>

        </Layout>
        <StatusBar backgroundColor='#134A93' style="light" />
      </Layout>
  );
};

const styles = StyleSheet.create({
  container:{
    flex:1,
  },
});
